import {GUID} from "../../shared/models/GUID-interface";

export class StocksFiltersState {
    constructor(

    ) {
        this.warehouses = false;
        this.skus = false;
        this.suppliers = false;
        this.extsuppliers = false;
        this.altgroup = false;
        this.category = false;
        this.group = false;
        this.subgroup1 = false;
        this.subgroup2 = false;
        this.subgroup3 = false;
        this.subgroup4 = false;
        this.subgroup5 = false;
        this.generalskucode = false;
        this.manager = false;
        this.manufacturer = false;
        this.brand = false;
        this.state = false;
        this.actionmovers = false;
        this.seasonmovers = false;
        this.speedmovers = false;
        this.topmovers = false;
        this.thrmovers = false;
        this.lspeedmovers = false;
        this.ltopmovers = false;
        this.lthrmovers = false;
        this.fresh = false;
        this.bufferlimits = false;
        this.storetype = false;
        this.warehousestatus = false;
        this.bufferzones = false;
        this.actionstatus = false;
        this.new = false;
        this.firstprice = false;
        this.blockedtoorder = false;
        this.supplierholiday = false;
        this.itemid = false;
        this.orderday = false;
        this.arriveday = false;
        this.scheduleExists= false;
        this.orderCycleType = false;
        this.schedulecycletype = false;
        this.scheduletype = false;
        this.buffer = false;
        this.balance = false;
        this.obvalue = false;
        this.intransit = false;
        this.otbvalue = false;
        this.otbdiff = false;
        this.order = false;
        this.package = false;
        this.shelfqnt = false;
        this.safetystock = false;
    }

    public warehouses: boolean;
    public skus: boolean;
    public suppliers: boolean;
    public extsuppliers: boolean;
    public altgroup: boolean;
    public category: boolean;
    public group: boolean;
    public subgroup1: boolean;
    public subgroup2: boolean;
    public subgroup3: boolean;
    public subgroup4: boolean;
    public subgroup5: boolean;
    public generalskucode: boolean;
    public manager: boolean;
    public manufacturer: boolean;
    public brand: boolean;
    public state: boolean;
    public actionmovers: boolean;
    public seasonmovers: boolean;
    public speedmovers: boolean;
    public topmovers: boolean;
    public thrmovers: boolean;
    public lspeedmovers: boolean;
    public ltopmovers: boolean;
    public lthrmovers: boolean;
    public fresh: boolean;
    public bufferlimits: boolean;
    public storetype: boolean;
    public warehousestatus: boolean;
    public bufferzones: boolean;
    public actionstatus: boolean;
    public new: boolean;
    public firstprice: boolean;
    public blockedtoorder: boolean;
    public supplierholiday: boolean;
    public itemid: boolean;
    public orderday: boolean;
    public arriveday: boolean;
    public scheduleExists: boolean;
    public orderCycleType: boolean;
    public schedulecycletype: boolean;
    public scheduletype: boolean;
    public buffer: boolean;
    public balance: boolean;
    public obvalue: boolean;
    public intransit: boolean;
    public otbvalue: boolean;
    public otbdiff: boolean;
    public order: boolean;
    public package: boolean;
    public shelfqnt: boolean;
    public safetystock: boolean;
}

export class StocksFiltersStateGUID implements  GUID{
    constructor(public readonly GUID: string, public stocksFiltersState: StocksFiltersState) {

    }
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/stocks-filters-state.ts